export const getUniqueItemsByKey = <T>(arr: T[], key: keyof T): T[] => {
	const listWithKeys = arr.filter((item) => item?.[key]);
	const uniqueMap = new Map(listWithKeys.map((item) => [item[key], item]));
	return Array.from(uniqueMap.values());
};
